import { UtilityModule } from "@/core/modules/utility/objects/UtilityModule";

import DownloadHealthFolderView from "./views/DownloadHealthFolderView.vue";

export const downloadHealthFolder: UtilityModule = new UtilityModule("healthProtocol", "DownloadHealthFolder", "utility", DownloadHealthFolderView);
